import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

const AddCustomPromptDialog = ({
  open,
  onClose,
  title,
  promptTitle,
  onPromptTitleChange,
  promptText,
  onPromptTextChange,
  onSavePrompt,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          backgroundImage: 'none',
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Prompt Title"
          fullWidth
          value={promptTitle}
          onChange={onPromptTitleChange}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Prompt Text"
          multiline
          rows={4}
          fullWidth
          value={promptText}
          onChange={onPromptTextChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onSavePrompt}
          variant="contained"
          disabled={!promptTitle.trim() || !promptText.trim()}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCustomPromptDialog;
